'use client';
import Image from 'next/image';
import Link from 'next/link';

const partnersCollaborators = [
  {
    alt: "south-asia-blockchain-week",
    src: "/images/south-asia-blockchain-week.webp",
  },
  {
    alt: "global-blockchain-show",
    src: "/images/global-blockchain-show.svg",
  },
  {
    alt: "global-games-show.svg",
    src: "/images/global-games-show.svg",
  },
  {
    alt: "ton",
    src: "/images/ton.svg",
  },
  {
    alt: "eth-belgarde",
    src: "/images/eth-belgarde.svg",
  },
  {
    alt: "tech",
    src: "/images/tech.webp",
  },
  {
    alt: "foundership",
    src: "/images/foundership.webp",
  },
  {
    alt: "paradise-capital",
    src: "/images/paradise-capital.webp",
  },
  {
    alt: "newtribe-capital-logo",
    src: "/images/newtribe-capital-logo.svg",
  },
  {
    alt: "rework",
    src: "/images/rework-logo.svg",
    link: "https://ny-ai-finance.re-work.co/",
  },
  {
    alt: "Corinium",
    src: "/images/corinium-logo-new.webp",
    link: "https://cdaofs.coriniumintelligence.com/",
  },

];

const PartnersCollaborators = () => {
  return (
    <section data-component-id="src/app/PartnersCollaborators.jsx:57:4" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="57" data-component-file="PartnersCollaborators.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners-collaborators%22%2C%22className%22%3A%22w-full%20bg-%5Blinear-gradient(360deg%2C%23060606_0%25%2C%23000000_70%25%2C_%23120049_100%25)%5D%20mx-auto%20px-4%20py-12%20flex%20flex-col%20items-center%20justify-center%20sm%3Apt-%5B80px%5D%20sm%3Apb-%5B80px%5D%20py-%5B40px%5D%20%22%7D"
      id="partners-collaborators"
      className="w-full bg-[linear-gradient(360deg,#060606_0%,#000000_70%,_#120049_100%)] mx-auto px-4 py-12 flex flex-col items-center justify-center sm:pt-[80px] sm:pb-[80px] py-[40px] "
    >
      <div data-component-id="src/app/PartnersCollaborators.jsx:61:6" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="61" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/PartnersCollaborators.jsx:63:8" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="63" data-component-file="PartnersCollaborators.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22uppercase%20text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20lg%3Atext-%5B28px%5D%20font-open-sans%20font-semibold%20leading-8%20sm%3Aleading-9%20md%3Aleading-10%20lg%3Aleading-%5B39px%5D%20text-center%20text-white%20pb-%5B30px%5D%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="uppercase text-2xl sm:text-3xl md:text-4xl lg:text-[28px] font-open-sans font-semibold leading-8 sm:leading-9 md:leading-10 lg:leading-[39px] text-center text-white pb-[30px]">
          Past Partners & Collaborators
        </h2>

        {/* Partner Logos Box */}
        <div data-component-id="src/app/PartnersCollaborators.jsx:68:8" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="68" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-white%20rounded-%5B16px%5D%20p-6%20sm%3Ap-10%20md%3Ap-14%20lg%3Ap-%5B64px_36px%5D%20border%20border-gray-200%22%7D" className="w-full bg-white rounded-[16px] p-6 sm:p-10 md:p-14 lg:p-[64px_36px] border border-gray-200">
          {/* First row → only first 3 */}
          <div data-component-id="src/app/PartnersCollaborators.jsx:70:10" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="70" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-3%20gap-6%20sm%3Agap-8%20lg%3Agap-10%20place-items-center%20mb-8%22%7D" className="grid grid-cols-3 gap-6 sm:gap-8 lg:gap-10 place-items-center mb-8">
            {partnersCollaborators.slice(0, 3).map((partner, index) =>
              partner.link ? (
                <Link data-component-id="src/app/PartnersCollaborators.jsx:73:16" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="73" data-component-file="PartnersCollaborators.jsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D" key={index} href={partner.link} target="_blank"  rel="noopener noreferrer nofollow">
                  <Image data-component-id="src/app/PartnersCollaborators.jsx:74:18" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="74" data-component-file="PartnersCollaborators.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20h-%5B80px%5D%20w-%5B170px%5D%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                    src={partner.src}
                    alt={partner.alt}
                    width={170}
                    height={80}
                    unoptimized
                    className="object-contain h-[80px] w-[170px] transition-transform duration-200 hover:scale-105"
                  />
                </Link>
              ) : (
                <Image data-component-id="src/app/PartnersCollaborators.jsx:84:16" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="84" data-component-file="PartnersCollaborators.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20h-%5B80px%5D%20w-%5B170px%5D%22%7D"
                  key={index}
                  src={partner.src}
                  alt={partner.alt}
                  width={170}
                  height={80}
                  unoptimized
                  className="object-contain h-[80px] w-[170px]"
                />
              )
            )}
          </div>

          {/* Second row → remaining */}
          <div data-component-id="src/app/PartnersCollaborators.jsx:98:10" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="98" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20lg%3Agrid-cols-6%20gap-4%20sm%3Agap-8%20lg%3Agap-10%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-8 lg:gap-10 place-items-center">
            {partnersCollaborators.slice(3).map((partner, index) =>
              partner.link ? (
                <Link data-component-id="src/app/PartnersCollaborators.jsx:101:16" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="101" data-component-file="PartnersCollaborators.jsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D" key={index} href={partner.link} target="_blank"  rel="noopener noreferrer nofollow">
                  <Image data-component-id="src/app/PartnersCollaborators.jsx:102:18" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="102" data-component-file="PartnersCollaborators.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20h-%5B80px%5D%20w-%5B170px%5D%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                    src={partner.src}
                    alt={partner.alt}
                    width={170}
                    height={80}
                    unoptimized
                    className="object-contain h-[80px] w-[170px] transition-transform duration-200 hover:scale-105"
                    
                  />
                </Link>
              ) : (
                <Image data-component-id="src/app/PartnersCollaborators.jsx:113:16" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="113" data-component-file="PartnersCollaborators.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20h-%5B80px%5D%20w-%5B170px%5D%22%7D"
                  key={index}
                  src={partner.src}
                  alt={partner.alt}
                  width={170}
                  height={80}
                  unoptimized
                  className="object-contain h-[80px] w-[170px]"
                  
                />
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersCollaborators;
